/* eslint-disable formatjs/no-literal-string-in-jsx */
import { Box, Text } from '@atlaskit/primitives';
import { DatabaseFieldType } from '@databases/types/database';
import React, { type FunctionComponent } from 'react';

type FieldSettingsOptionsByTypeProps = {
  fieldType: DatabaseFieldType;
};

const unreachable = (fieldType: never): never => {
  throw new Error(`Unsupported field settings menu type: ${fieldType}`);
};

const FieldSettingsPlaceholder: FunctionComponent<FieldSettingsOptionsByTypeProps> = ({
  fieldType
}) => {
  return (
    <Box paddingBlock="space.100">
      <Text>
        {fieldType}
        {
          // temporary placeholder
        } field settings placeholder
      </Text>
    </Box>
  );
};

const FieldSettingsOptionsByType: FunctionComponent<FieldSettingsOptionsByTypeProps> = ({
  fieldType
}) => {
  switch (fieldType) {
    case DatabaseFieldType.ATTACHMENT:
      return <FieldSettingsPlaceholder fieldType={fieldType} />;

    case DatabaseFieldType.BACKLINK:
      return <FieldSettingsPlaceholder fieldType={fieldType} />;

    case DatabaseFieldType.DATE:
      return <FieldSettingsPlaceholder fieldType={fieldType} />;

    case DatabaseFieldType.ENTRY_DETAILS:
      return <FieldSettingsPlaceholder fieldType={fieldType} />;

    case DatabaseFieldType.ENTRY_LINK:
      return <FieldSettingsPlaceholder fieldType={fieldType} />;

    case DatabaseFieldType.HYPERLINK:
      return <FieldSettingsPlaceholder fieldType={fieldType} />;

    case DatabaseFieldType.JIRA_ISSUE:
      return <FieldSettingsPlaceholder fieldType={fieldType} />;

    case DatabaseFieldType.JIRA_ISSUE_DETAILS:
      return <FieldSettingsPlaceholder fieldType={fieldType} />;

    case DatabaseFieldType.NUMBER:
      return <FieldSettingsPlaceholder fieldType={fieldType} />;

    case DatabaseFieldType.PAGE_DETAILS:
      return <FieldSettingsPlaceholder fieldType={fieldType} />;

    case DatabaseFieldType.PAGE_LABELS:
      return <FieldSettingsPlaceholder fieldType={fieldType} />;

    case DatabaseFieldType.PAGE_LINK:
      return <FieldSettingsPlaceholder fieldType={fieldType} />;

    case DatabaseFieldType.PAGE_STATUS:
      return <FieldSettingsPlaceholder fieldType={fieldType} />;

    case DatabaseFieldType.SELECT:
      return <FieldSettingsPlaceholder fieldType={fieldType} />;

    case DatabaseFieldType.TEXT:
      return <FieldSettingsPlaceholder fieldType={fieldType} />;

    case DatabaseFieldType.USER:
      return <FieldSettingsPlaceholder fieldType={fieldType} />;

    case DatabaseFieldType.AI_SUMMARY:
    case DatabaseFieldType.CHECKBOX:
      return null; // Won't be supporting these field types

    default:
      return unreachable(fieldType);
  }
};

export default FieldSettingsOptionsByType;
